import React, { useRef, useState, useEffect } from 'react';
import Tour from '@/components/Tour';
import { useStore } from '@/hooks/storeHooks'

const Guide = ()=> {
  const tourRef = useRef()
  const styles = {
    width:'128px',
    height: '46px',
    border: '1px solid #ffffff',
    borderRadius: '12px',
    position: 'absolute',
    bottom: '35px',
    right: '168px',
    cursor: 'pointer',
    lineHeight: '46px',
    textAlign: 'center',
    color: '#fff'
  }
  const { user } = useStore()
  const [showTour, setShowTour] = useState(false);
  useEffect(() => {
    if(user.needShowTour) {
      setShowTour(true)
      user.setNeedShowTourr(false)
    }
  }, [user.needShowTour]);
  return (
    <>
      <Tour
        ref={tourRef}
        list={[
          {target: 'guide_fixbar'},
        ]}
        visible={showTour}
      >
        <div>
          <img style={{
            width:'532px',top:'302px',transform:'translate(-100%,0)',marginLeft:'80px'
            }}
            src="https://osscdn2.zhongheschool.com/common/defaultType/202312/202312011818260162.png" alt=""
          />
          <div style={styles} onClick={()=>tourRef.current?.close()}>我知道了</div>
        </div>
      </Tour>
    </>
  )
}

export default Guide